'use client'
import React, { useState } from 'react'
import Logo from '../Logo'
import Link from 'next/link'
import CtaButton from '../CtaButton'
import { Button } from '@/components/ui/button'
import { Menu } from 'lucide-react'

const DesktopNavbar = () => {
  const [visible, setVisible] = useState(false);
  return (
    <nav className='flex justify-between items-center py-2 sm:py-0 pl-2 pr-2 sm:pl-5 sm:pr-10 relative'>
      <div className='hidden sm:block'>
        <Logo />
      </div>
      <div className='sm:hidden flex gap-2 items-center'>
        <Logo size='small'/>
        <h1 className='text-lg font-bold text-[#2E3192]'>SKILL{" "}<span className='text-[#00904C]'>SEWA</span></h1>
      </div>
      <ul className='hidden sm:flex gap-8 text-lg'>
        <li>
          <Link href={'/'}>Home</Link>
        </li>
        <li>
          <Link href={'/#about'}>About</Link>
        </li>
        <li>
          <Link href={'/services'}>Services</Link>
        </li>
        <li>
          <Link href={'/construction'}>Construction</Link>
        </li>
        <li>
          <Link href={'/blogs'}>Blogs</Link>
        </li>
        <li>
          <Link href={'/#contact'}>Contact</Link>
        </li>
      </ul>
      <div className='hidden sm:block'>
        <CtaButton aria-label="navigation menu"/>
      </div>
      <Button aria-label="toggle navigation menu" className='sm:hidden' onClick={() => setVisible(!visible)} variant="ghost">
        <Menu className='h-4 w-4' />
      </Button>
      {visible && (
        <div className='absolute top-14 right-0 w-full h-[calc(100vh-4rem)] bg-zinc-50/70 backdrop-blur-[2px] z-10'>
          <ul className='flex flex-col gap-8 text-lg p-10'>
            <li>
              <Link href={'/'} onClick={() => setVisible(!visible)}>Home</Link>
            </li>
            <li>
              <Link href={'/'} onClick={() => setVisible(!visible)}>About</Link>
            </li>
            <li>
              <Link href={'/services'} onClick={() => setVisible(!visible)}>Services</Link>
            </li>
            <li>
              <Link href={'/construction'} onClick={() => setVisible(!visible)}>Construction</Link>
            </li>
            <li>
              <Link href={'/blogs'} onClick={() => setVisible(!visible)}>Blogs</Link>
            </li>
            <li>
              <Link href={'/'} onClick={() => setVisible(!visible)}>Contact</Link>
            </li>
          </ul>
        </div>
      )}
    </nav>
  )
}

export default DesktopNavbar
